import { render, staticRenderFns } from "./productHeaderNav.vue?vue&type=template&id=63c1f9fb&"
import script from "./productHeaderNav.vue?vue&type=script&lang=js&"
export * from "./productHeaderNav.vue?vue&type=script&lang=js&"
import style0 from "./productHeaderNav.vue?vue&type=style&index=0&id=63c1f9fb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports